import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';

const UsersTable = ({
  setUserToEdit,
  displayEditButton,
  displayDeleteButton,
  users,
  loader,
  setUserToDelete,
  setUserToEditRoles,
  setUserToDisable,
  handleViewAudit,
  // server-side pagination props
  page,
  rowsPerPage,
  hasNextPage,
  onPageChange,
  onRowsPerPageChange,
  onSearch,
}) => {
  const [selectedUser, setSelectedUser] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchInput, setSearchInput] = useState('');

  const usersdata = users || [];

  const handleMenuOpen = (rowData, event) => {
    setSelectedUser(rowData);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSearchSubmit = () => {
    onSearch(searchInput);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') onSearch(searchInput);
  };

  const totalCount = hasNextPage ? (page + 1) * rowsPerPage + 1 : page * rowsPerPage + usersdata.length;

  if (loader) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
        <Typography variant="h6" style={{ marginLeft: 16 }}>Loading users...</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search users by name, username, or email..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={handleKeyDown}
          size="small"
        />
        <Button
          variant="contained"
          onClick={handleSearchSubmit}
          style={{ background: '#003643', whiteSpace: 'nowrap' }}
        >
          Search
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table aria-label="users table">
          <TableHead>
            <TableRow>
              {['FirstName', 'Last Name', 'Username', 'Email', 'Created At', 'Action'].map(function(header) {
                return (
                  <TableCell key={header} sx={{ backgroundColor: '#003643', color: '#FFF', fontWeight: 'bold' }}>
                    {header}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {usersdata.map(function(user, index) {
              return (
                <TableRow key={user.id || index} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                  <TableCell>{user.firstName || ''}</TableCell>
                  <TableCell>{user.lastName || ''}</TableCell>
                  <TableCell>{user.username || ''}</TableCell>
                  <TableCell>{user.email || ''}</TableCell>
                  <TableCell>{user.createdTimestamp ? new Date(user.createdTimestamp).toLocaleDateString() : ''}</TableCell>
                  <TableCell>
                    <IconButton onClick={function(e) { handleMenuOpen(user, e); }} size="small">
                      <MoreVertIcon />
                    </IconButton>
                    {selectedUser.id === user.id && (
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={function() { setAnchorEl(null); setUserToEdit(user); }}>Edit User/partner</MenuItem>
                        <MenuItem onClick={function() { setAnchorEl(null); setUserToEditRoles(user); }}>Edit User Roles</MenuItem>
                        <MenuItem onClick={function() { setAnchorEl(null); setUserToDelete(user); }}>Delete User</MenuItem>
                        <MenuItem onClick={function() { setAnchorEl(null); setUserToDisable(user); }}>Disable User</MenuItem>
                        <MenuItem onClick={function() { setAnchorEl(null); handleViewAudit(user); }}>View User Activity</MenuItem>
                      </Menu>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
            {usersdata.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="body1" color="textSecondary">
                    {searchInput ? 'No users found matching your search.' : 'No users found.'}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={function(e, newPage) { onPageChange(newPage); }}
          onRowsPerPageChange={function(e) { onRowsPerPageChange(parseInt(e.target.value, 10)); }}
          labelDisplayedRows={function(p) {
            return 'Page ' + (p.page + 1);
          }}
        />
      </TableContainer>
    </>
  );
};

export default UsersTable
